import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { DownloadFileService } from '../download-files-service/download-file.service';
import { BehaviorSubject } from 'rxjs';
import { UsuarioServiceProvider } from '../index.providers';

@Injectable({
  providedIn: 'root'
})
export class NotificationsActivitiesService {
  private allNotifications = new BehaviorSubject<any[]>([]);
  allNotifications$ = this.allNotifications.asObservable();

  private isLoading = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoading.asObservable();

  private paginationInfo = new BehaviorSubject<any>(null);
  public paginationInfo$ = this.paginationInfo.asObservable();

  private newNotificationArrived = new BehaviorSubject<boolean>(false);
  public $newNotificationArrived = this.newNotificationArrived.asObservable();
  refreshDataInProgress: boolean = false;

  constructor(
    private api: ApiService,
    private router: Router,
    private downloadFileService: DownloadFileService,
    private up: UsuarioServiceProvider
  ) {

  }

  initNotificationsAndActivities() {
    this.up.isLogged.subscribe((isLogged) => {
      // console.log("notific service constructor: ", res);
			if (isLogged) {
        setTimeout(() => {
          this.handleNotificationUpdate(true, false, 1);
        }, 50);
			} else {
        this.allNotifications.next([]);
        this.paginationInfo.next(null);
        this.newNotificationArrived.next(false);
      }
		});
  }

  async readNotification(notification){
    await this.api.markAsReadNotification(notification?.id, true)
    .then((res) => {
      if(res?.success){
        notification.is_read = 1;
        this.handleNotificationUpdate(false, false, 1);
        if(notification?.path){
          this.pathNotification(notification);
        }
      }
    })
    .catch((e) => {
      console.log(e)
      // this.pathNotification(notification);
    });
  }

  handleNotificationUpdate(refreshNotificationsList:boolean, forceRefresh: boolean = false, page: number = 1, status: string = 'all', modality: string = '') {
    if(refreshNotificationsList){
      const apiUrl =  this.api.getApiUrls;
      if((!this.refreshDataInProgress || forceRefresh) && apiUrl?.serviceBase){
        this.refreshDataInProgress = true;
        this.isLoading.next(true);
        this.api.listNotifications(page, status, modality).then(({data, pagination}) => {
          // console.log(data)
          this.allNotifications.next(data);
          this.paginationInfo.next(pagination || null);
          this.refreshNotificationBellBadge();
          this.isLoading.next(false);
          setTimeout(() => {
            this.refreshDataInProgress = false;
          }, 300000); //5 min
        }).catch((err) => {
          console.log(err)
          this.refreshDataInProgress = false;
          this.isLoading.next(false);
        })
      }
    }
    else {
      // this.listNotification.next(data); // sin usar
      this.refreshNotificationBellBadge();
    }
  }

  refreshNotificationBellBadge(){
    const newNotification:boolean = this.allNotifications.getValue().some(e => e.notifications.some(notification => !notification.is_read && notification.is_visible ));
    this.newNotificationArrived.next(newNotification);
  }

  async pathNotification(notification){
    console.log("Navigating to notification path: ", notification);
      if(notification?.path){
        if(notification.type?.code === 'new-course'){
          let extras: NavigationExtras = {
            queryParams: {
              idN: JSON.stringify(notification.id),
            },
          };
          this.router.navigateByUrl(`${notification.path}?idN=${notification.id}`);
        } else if (notification?.path === "/lista-checklists" &&  notification.download_url ) {
          this.downloadFileService.downloadMediaWithBrowser(notification.download_url);
        }
        else {
          this.router.navigateByUrl(notification?.path);
        }
      }
      else if (notification?.type?.code === 'in-person' && !notification?.path ) {
          this.router.navigate(['/calendar-pending-activities/calendar']);
      }
  }

  iconNotification(type){
    switch (type) {
      case 'new-course':
        return 'mdi-book-open-page-variant';
      case 'password-reset':
        return 'mdi-lock-reset'
      case 'password-update':
        return 'mdi-lock-reset'
      case 'ticket-solved':
        return 'mdi-help-circle';
      case 'new-benefit':
          return 'mdi-gift-open';
      case 'new-certificate':
        return 'mdi-certificate';
      case 'new-document':
        return 'mdi-multimedia';
      case 'new-video':
        return 'mdi-file-video'
      case 'new-homework':
          return 'mdi-book-arrow-down';
      case 'email-update':
        return 'mdi-email-fast';
      case 'new-announcement':
        return 'mdi-bullhorn';
      case 'new-meeting':
        return 'mdi-video';
      default:
        return 'mdi-message-star';
    }
  }

  goToCalendar() {
    this.router.navigate(['/calendar-pending-activities/calendar']);
  }


}

